// Report grouping keys: sub1..sub30 plus custom campaign parameters, as
// returned by GET /analytics/param-keys. Pure helpers, unit-tested.

export const STANDARD_SUB_KEYS = Array.from({ length: 30 }, (_, i) => 'sub' + (i + 1));

// Picker label: "sub1 · Team" when the campaign named the key, else the key.
export function paramKeyLabel(entry) {
  if (!entry) return '';
  return entry.label ? entry.key + ' · ' + entry.label : entry.key;
}

// Fallback when the endpoint is unavailable: the standard sub keys only.
export function normalizeParamKeys(payload) {
  const keys = payload && Array.isArray(payload.keys) ? payload.keys : null;
  if (!keys || !keys.length) {
    return STANDARD_SUB_KEYS.map((k) => ({ key: k, label: '', standard: true }));
  }
  return keys.filter((e) => e && typeof e.key === 'string' && e.key);
}

export function customParamKeys(entries) {
  return (entries || []).filter((e) => !e.standard);
}
